<div class="city-info">
    <div class="city-info__content">
        <div class="city-info__map" #locationsRef>
            @if (!isFetching) {
                <app-simple-map
                        [coordinates]="countryInfoParseService.mapCoordinates$ | async | parseCoordinates"
                ></app-simple-map>
            } @else {
                <ngx-skeleton-loader
                        [theme]="{height: locationsRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
            }
        </div>
        <div class="city-info__items">
            <div class="city-info__breadcrumbs">
                <app-simple-breadcrumb [breadcrumbs]="breadcrumbs"></app-simple-breadcrumb>
            </div>

            <div class="city-info__anchor">
                <div class="swiper-container" appSwiper [swiperOptions]="anchorSwiperOptions">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(0)">Info</button>
                        </div>
                        <div class="swiper-slide">
                            <button class="tab-button" (click)="scrollToAnchor(1)">Hotels</button>
                        </div>
                        @if ((categoriesResponse | keyvalue)?.length || isFetching) {
                            <div class="swiper-slide">
                                <button class="tab-button" (click)="scrollToAnchor(2)">Landmarks & Activities</button>
                            </div>
                        }
                        @if (occasionGeniusResponse?.eventsSearchedAndSorted?.length || isFetching) {
                            <div class="swiper-slide">
                                <button class="tab-button" (click)="scrollToAnchor(3)">Events and Occasions</button>
                            </div>
                        }
                        @if (voiceMapResponse?.guidedTours?.length || isFetching) {
                            <div class="swiper-slide">
                                <button class="tab-button" (click)="scrollToAnchor(4)">Voice Guide</button>
                            </div>
                        }
                        @if (cityResponse.attractionsSearchedAndSorted?.length || isFetching) {
                            <div class="swiper-slide">
                                <button class="tab-button" (click)="scrollToAnchor(5)">Attractions</button>
                            </div>
                        }
                        @if (countryResponse.itineraries?.length || isFetching) {
                            <div class="swiper-slide">
                                <button class="tab-button" (click)="scrollToAnchor(6)">Trips</button>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div id="element-id-0" class="city-info__details">
                <h2>About {{ defaultLocationName | replaceStr: ' ' | titlecase }}</h2>
                @if (!isFetching) {
                    <app-text-ellipsis
                            [short]="cityDetails.shortDescription"
                            [long]="cityDetails.description"
                            [extra]="cityDetails.extraDescription"
                    ></app-text-ellipsis>
                } @else {
                    <ngx-skeleton-loader [theme]="{height: '16px', margin: 0}"></ngx-skeleton-loader>
                    <ngx-skeleton-loader [theme]="{height: '16px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                    <ngx-skeleton-loader [theme]="{height: '16px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                }
            </div>

            <section>
                <app-gallery-mobile
                        [destinations]="regionDetails.destinations"
                        (selectedItem)="flyToGalleryItem($event)"
                ></app-gallery-mobile>

                @if (cityResponse?.thingsToDo && cityResponse?.thingsToDo[0] && (cityResponse?.thingsToDo[0]?.things_todo_extra_description ||
                cityResponse?.thingsToDo[0]?.things_todo_short_description ||
                cityResponse?.thingsToDo[0]?.things_todo_long_description | extractFirstParagraph)) {
                    <div class="city-info__details">
                        <h2>{{ 'THINGS_TO_DO.THINGS_TO_DO_IN' | translate: {location: defaultLocationName | replaceStr: ' ' | titlecase} }}</h2>

                        @if (!isFetching) {
                            @if (cityResponse?.thingsToDo.length) {
                                @if (cityResponse?.thingsToDo[0]; as thingsToDo) {
                                    <app-text-ellipsis
                                            [thingsToDoCity]="cityResponse.cityInfo.getFirstCity().name"
                                            [thingsToDoShort]="thingsToDo.things_todo_short_description"
                                    ></app-text-ellipsis>
                                }
                            }
                        } @else {
                            <div class="location-info__content">
                                <ngx-skeleton-loader [theme]="{height: '20px', margin: 0}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                            </div>
                        }
                    </div>
                }
            </section>

            <section id="element-id-1">
                <app-hotels-booking-container
                        [showFilters]="false"
                        [city]="{id: cityDetails.place_id, cityName: cityDetails.name}"
                        [country]="{id: null, countryName: countryDetails.name}"
                ></app-hotels-booking-container>
            </section>

            @if ((categoriesResponse | keyvalue)?.length || isFetching) {
                <section id="element-id-2">
                    <app-viator
                            [cityId]="cityDetails.place_id"
                            [cityName]="cityDetails?.name"
                            [countryName]="countryDetails.name"
                            [categories]="categoriesResponse"
                            [isFetching]="isFetching"
                            (numOfAllHurted)="numOfHurt = $event"
                    ></app-viator>
                </section>
            }

            @if (occasionGeniusResponse?.eventsSearchedAndSorted?.length || isFetching) {
                <section id="element-id-3">
                    <app-occasion-genius
                            [cityId]="cityDetails.place_id"
                            [cityName]="defaultLocationName | replaceStr: ' ' | titlecase"
                            [countryName]="countryDetails.name"
                            [isFetching]="isFetching"
                            [occasionGeniusResponse]="occasionGeniusResponse"
                            [eventsSearchedAndSorted]="occasionGeniusResponse.eventsSearchedAndSorted"
                    ></app-occasion-genius>
                </section>
            }

            @if (voiceMapResponse?.guidedTours?.length || isFetching) {
                <section id="element-id-4">
                    <app-audio-tours
                            [itineraryItem]="voiceMapResponse.guidedTours"
                            [isFetching]="isFetching"
                            [countryName]="countryDetails.name"
                            [cityName]="cityDetails.name"
                    ></app-audio-tours>
                </section>
            }

            @if (cityResponse?.attractionsSearchedAndSorted?.length || isFetching) {
                <section id="element-id-5">
                    <app-attraction-list-mobile
                            [countryName]="cityDetails.name"
                            [attractions]="cityResponse.attractionsSearchedAndSorted"
                    ></app-attraction-list-mobile>
                </section>
            }

            @if (countryResponse.itineraries?.length || isFetching) {
                <section id="element-id-6">
                    <app-itinerary-list-mobile
                            [isFetching]="isFetching"
                            [countryName]="countryDetails.name"
                            [itineraries]="countryResponse.itineraries"
                    ></app-itinerary-list-mobile>
                </section>
            }
        </div>
    </div>

    <div class="city-info__footer">
        <app-start-planing-mobile></app-start-planing-mobile>
    </div>
</div>
